import defaultState from './defaultState'

const unwrapState = state => state.share || defaultState

export const getNativeShareSupport = state => unwrapState(state).support
export const isShareOpen = state => unwrapState(state).open
export const getShareData = state => unwrapState(state).data
